import { map } from 'lodash';
import { Radio as BaseRadio } from 'native-base';
const Radio = (props) => {
    const { options, onChange, value, ...rest } = props;
    return (<BaseRadio.Group space={4} name="" value={value} onChange={onChange} {...rest}>
      {map(options, (option) => (<BaseRadio value={option.value}>{option.label}</BaseRadio>))}
    </BaseRadio.Group>);
};
export default Radio;
